var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-nutrition-facts" },
    _vm._l(_vm.nutritionFacts, function(fact) {
      return _c("div", { staticClass: "product-nutrition-facts__fact" }, [
        _c("div", { staticClass: "product-nutrition-facts__fact-number" }, [
          _vm._v(_vm._s(fact.value))
        ]),
        _c("div", { staticClass: "product-nutrition-facts__fact-title" }, [
          _vm._v(_vm._s(fact.name))
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }